package amazon.lastmile.inject

import app.nestbridge.feature.invitations.service.DefaultInvitationService
import app.nestbridge.feature.invitations.service.InvitationService
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DefaultInvitationService::class)
public interface AppNestbridgeFeatureInvitationsServiceDefaultInvitationService {
  @Provides
  public fun provideDefaultInvitationServiceInvitationService(defaultInvitationService: DefaultInvitationService): InvitationService = defaultInvitationService
}
